export default __webpack_public_path__ + "locales/it/Payments.json?hash=7629f1f326d751cc9332d795795adff1";